import { TuiIconTdsSmallPragmaticMinus, TuiIconTdsSmallPragmaticPlus } from '@tui-react/proprietary-icons';
import React, { useLayoutEffect, useRef } from 'react';
import styles from './ImageZoomSlider.module.css';

interface ImageZoomSliderProps {
  value: number;
  min: number;
  max: number;
  step: number;
  onChange(value: number): void;
}

export const ImageZoomSlider: React.FC<ImageZoomSliderProps> = ({ value, min, max, step, onChange }) => {
  const sliderRef = useRef<HTMLInputElement>(null);

  const updateSliderBackground = () => {
    const slider = sliderRef.current;

    if (!slider) {
      return;
    }

    const value = Number(slider.value);
    const min = Number(slider.min);
    const max = Number(slider.max);

    slider.style.backgroundSize = ((value - min) * 100) / (max - min) + '% 100%';
  };

  const handleSliderChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    onChange(Number(target.value));
  };

  const handleZoomInClick = () => {
    onChange(Math.min(value + step, max));
  };

  const handleZoomOutClick = () => {
    onChange(Math.max(value - step, min));
  };

  const handleSliderKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    event.stopPropagation();
  };

  useLayoutEffect(() => {
    updateSliderBackground();
  }, [value]);

  const isZoomInDisabled = value === max;
  const isZoomOutDisabled = value === min;

  return (
    <div className={styles.container}>
      <button className={styles.iconButton} onClick={handleZoomInClick} disabled={isZoomInDisabled}>
        <TuiIconTdsSmallPragmaticPlus iconSize="var(--icon-xs)" />
      </button>

      <div className={styles.sliderContainer}>
        <input
          ref={sliderRef}
          className={styles.slider}
          type="range"
          value={value}
          min={min}
          max={max}
          onChange={handleSliderChange}
          onKeyDown={handleSliderKeyDown}
        />
      </div>

      <button className={styles.iconButton} onClick={handleZoomOutClick} disabled={isZoomOutDisabled}>
        <TuiIconTdsSmallPragmaticMinus iconSize="var(--icon-xs)" />
      </button>
    </div>
  );
};
